import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { FeatureFlagsResultModel } from "../interfaces/entities/feature-flag";

@Injectable({
  providedIn: "root",
})
export class FeatureFlagService {
  constructor(private apiService: ApiBaseService) {}

  getAllFeatureFlags(): Promise<FeatureFlagsResultModel> {
    return this.apiService.httpRequest(
      "FeatureFlag/GetAllFeatureFlags",
      {},
      true,
      true
    );
  }
}
